//
//
//
//
//

// 按需引入部分组件
import action from './action';

export default {
  name: 'index',
  props: ['params'],
  created: async function () {
    let { inviteCode, code, state } = this.params;
    inviteCode = inviteCode || state;
    let acIds = inviteCode.split('-');
    G.member = JSON.parse(localStorage.getItem(acIds[0]) || '{}');
    console.log("member======>", G.member);
    if(G.member && G.member.token){
      await this.jumpActivity(inviteCode);
    }else {
      if(code){
        await this.loginByCode(code, state);
      }else {
        await this.authorizeMeitu(inviteCode);
      }
    }
  },
  data() {
    return {
      info: {}
    };
  },
  computed: {},
  filters: {},
  components: {},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/meituAuth/page.vue